import React from 'react'
import "../Footer/Footer.css"
const Footer = () => {
  return (
    <div className='footer'>
      <h2>Copyright &#xA9; 2023 TechnoBlitz</h2>
    </div>
  )
}

export default Footer